import { FeedbackCard } from "./FeedbackCard";

export const AppErrorState: React.FC<{
    message?: string;
    onRetry?: () => void;
    showRetry?: boolean
}> = ({
    message = "Failed to load questionnaire.",
    onRetry,
    showRetry = true
}) => (
        <FeedbackCard>
            <div className="flex flex-col items-center justify-center ">
                <div className="relative mb-6">
                    <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center animate-pulse">
                        <i className="bi bi-exclamation-triangle-fill text-red-500 text-4xl"></i>
                    </div>
                    <div className="absolute inset-0 border-2 border-red-200 rounded-full animate-ping opacity-75"></div>
                    <div className="absolute inset-2 border-2 border-red-300 rounded-full animate-ping opacity-50" style={{ animationDelay: '0.2s' }}></div>
                </div>

                <div className="text-center">
                    <h3 className="text-xl font-semibold text-[var(--color-gray-900]) mb-2">Oops! Something went wrong</h3>
                    <p className="text-red-600 font-medium mb-6">{message}</p>

                    {showRetry && onRetry && (
                        <button
                            onClick={onRetry}
                            className="inline-flex items-center px-6 py-3 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl"
                        >
                            <i className="bi bi-arrow-clockwise text-white text-lg mr-2"></i>
                            Try Again
                        </button>
                    )}
                </div>
            </div>
        </FeedbackCard>
    );
